var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('PrimaryButton',{class:_vm.css_class,attrs:{"type":"submit","title":_vm.titleMessage},nativeOn:{"click":function($event){return _vm.login.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }